/*
 * types/services/collection.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {CollectionCollectionBase} from './CollectionCollectionBase';
import {CollectionResponseCount} from './CollectionResponseCount';
import {CollectionResponseResponseState} from './CollectionResponseResponseState';

/**
 * The CollectionListCollectionResponse model module.
 * @module model/CollectionListCollectionResponse
 * @version version not set
 */
export class CollectionListCollectionResponse {
  /**
   * Constructs a new <code>CollectionListCollectionResponse</code>.
   * @alias module:model/CollectionListCollectionResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CollectionListCollectionResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CollectionListCollectionResponse} obj Optional instance to populate.
   * @return {module:model/CollectionListCollectionResponse} The populated <code>CollectionListCollectionResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CollectionListCollectionResponse();
      if (data.hasOwnProperty('result'))
        obj.result = ApiClient.convertToType(data['result'], [CollectionCollectionBase]);
      if (data.hasOwnProperty('count'))
        obj.count = CollectionResponseCount.constructFromObject(data['count']);
      if (data.hasOwnProperty('state'))
        obj.state = CollectionResponseResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {Array.<module:model/CollectionCollectionBase>} result
 */
CollectionListCollectionResponse.prototype.result = undefined;

/**
 * @member {module:model/CollectionResponseCount} count
 */
CollectionListCollectionResponse.prototype.count = undefined;

/**
 * @member {module:model/CollectionResponseResponseState} state
 */
CollectionListCollectionResponse.prototype.state = undefined;


